























































import { Vue, Component, Prop } from 'vue-property-decorator';

import { getTeamInfo } from '@/services/TeamService';
import TeamLogo from '@/components/common/team-logo/TeamLogo.vue';
import { FixtureInterface, TeamInterface } from '@/interfaces/interfaces';
import { getFixtureDate, isFixturePlayed, isFixtureCancelled } from '@/services/FixtureService';

@Component({
  components: { TeamLogo }
})
export default class ScoreCardDesktop extends Vue {
  @Prop() private showFixtureModal!: any;
  @Prop() private fixture!: FixtureInterface;

  private getTeamInfo(team: TeamInterface): TeamInterface {
    return getTeamInfo(team);
  }

  get fixtureDate() {
    return getFixtureDate(this.fixture);
  }

  get isFixturePlayed() {
    return isFixturePlayed(this.fixture);
  }

  get isFixtureCancelled() {
    return isFixtureCancelled(this.fixture);
  }

  get showMatchNumber() {
    return !(
      (this.fixture.round && this.fixture.round.length) ||
      (this.fixture.categoryType && this.fixture.categoryType.length)
    );
  }

  get isHomeTeamWinnerForNoScore() {
    return (
      isFixturePlayed(this.fixture) &&
      this.fixture.winnerTeam &&
      this.fixture.winnerTeam.id === this.fixture.homeTeam.id
    );
  }

  get isAwayTeamWinnerForNoScore() {
    return (
      isFixturePlayed(this.fixture) &&
      this.fixture.winnerTeam &&
      this.fixture.winnerTeam.id === this.fixture.awayTeam.id
    );
  }
}
